// extracted by mini-css-extract-plugin
export default {"SideMenu":"SideMenu_SideMenu__4N9rF","Menu":"SideMenu_Menu__eXyns","MenuActive":"SideMenu_MenuActive__AdfRN","Icon":"SideMenu_Icon__HSAbC"};